// src/ExpertAnalytics.jsx

import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, PieChart, Pie, Cell } from 'recharts';

const summaryStats = [
  { label: 'Total Sessions', value: 126 },
  { label: 'Revenue', value: '₹32,450' },
  { label: 'Clients Served', value: 42 },
  { label: 'Avg. Rating', value: '4.8★' },
];

const sessionData = [
  { month: 'Jan', sessions: 15 },
  { month: 'Feb', sessions: 22 },
  { month: 'Mar', sessions: 35 },
  { month: 'Apr', sessions: 25 },
  { month: 'May', sessions: 29 },
  { month: 'Jun', sessions: 34 },
];

const sessionTypes = [
  { name: '1:1 Calls', value: 55 },
  { name: 'Packages', value: 25 },
  { name: 'Webinars', value: 12 },
  { name: 'Digital Products', value: 8 },
];

const COLORS = ['#6366f1', '#10b981', '#f59e0b', '#ef4444'];

const ExpertAnalytics = () => {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-gray-800">Analytics Overview</h1>

      {/* Summary Cards */}
      <div className="grid gap-4 sm:grid-cols-2 md:grid-cols-4">
        {summaryStats.map((item, idx) => (
          <Card key={idx} className="bg-white shadow-sm border">
            <CardContent className="py-6 text-center">
              <p className="text-2xl font-semibold">{item.value}</p>
              <p className="text-sm text-gray-500">{item.label}</p>
            </CardContent>
          </Card>
        ))}
      </div>

      {/* Line Chart */}
      <Card className="bg-white shadow-sm border">
        <CardContent className="py-6">
          <h2 className="text-lg font-semibold mb-4">Monthly Sessions</h2>
          <ResponsiveContainer width="100%" height={300}>
            <LineChart data={sessionData}>
              <XAxis dataKey="month" />
              <YAxis />
              <Tooltip />
              <Line type="monotone" dataKey="sessions" stroke="#6366f1" strokeWidth={2} />
            </LineChart>
          </ResponsiveContainer>
        </CardContent>
      </Card>

      {/* Pie Chart */}
      <Card className="bg-white shadow-sm border">
        <CardContent className="py-6">
          <h2 className="text-lg font-semibold mb-4">Session Types Breakdown</h2>
          <ResponsiveContainer width="100%" height={280}>
            <PieChart>
              <Pie
                data={sessionTypes}
                dataKey="value"
                nameKey="name"
                cx="50%"
                cy="50%"
                outerRadius={100}
                label
              >
                {sessionTypes.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip />
            </PieChart>
          </ResponsiveContainer>
        </CardContent>
      </Card>
    </div>
  );
};

export default ExpertAnalytics;
